var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bell-notify__item", attrs: { role: "menuitem" } },
    [
      _c("div", { staticClass: "stack" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "stack-content", on: { click: _vm.showMessage } },
          [
            _c("h6", { staticClass: "media-heading" }, [
              _vm._v(_vm._s(_vm.item.title)),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "media-body" }, [
              _vm._v("\n        " + _vm._s(_vm.item.description) + "\n      "),
            ]),
            _vm._v(" "),
            _c("time", { staticClass: "media-meta", attrs: { datetime: "" } }, [
              _vm._v(_vm._s(_vm.item.created_at)),
            ]),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "stack-right" }, [
          !_vm.item.read_at
            ? _c("span", [
                _vm.reading_error
                  ? _c("span", [
                      _c("i", {
                        staticClass: "fa fa-exclamation-triangle",
                        attrs: {
                          "aria-hidden": "true",
                          "data-toggle": "tooltip",
                          "data-placement": "right",
                          "data-original-title": "Ошибка!",
                        },
                      }),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.reading_error && _vm.reading_loading
                  ? _c("span", [
                      _c("i", {
                        staticClass: "fa fa-spinner fa-pulse",
                        attrs: {
                          "aria-hidden": "true",
                          "data-toggle": "tooltip",
                          "data-placement": "right",
                          "data-original-title": "Загрузка...",
                        },
                      }),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.reading_error && !_vm.reading_loading
                  ? _c("span", [
                      _c(
                        "a",
                        {
                          staticClass: "bell-notify__btn",
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.readMessage(_vm.item.id)
                            },
                          },
                        },
                        [
                          _c("i", {
                            staticClass: "icon md-check",
                            attrs: {
                              id: "bellCheck",
                              "data-toggle": "tooltip",
                              "data-placement": "right",
                              "data-original-title":
                                "Отметить одно сообщение прочитанным",
                            },
                          }),
                        ]
                      ),
                    ])
                  : _vm._e(),
              ])
            : _vm._e(),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "stack-left" }, [
      _c("i", {
        staticClass: "icon md-info-outline",
        staticStyle: { "font-size": "14pt" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }